import React, { useState, useEffect, useRef } from 'react';
import { Container, Form, Image } from 'react-bootstrap';
import FormInput from '../../common/FormInput';
import FormLabel from '../../common/FormLabel';
import { HiOutlineChevronLeft } from '@react-icons/all-files/hi/HiOutlineChevronLeft';
import Select from 'react-select';
import { useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import LoadButton from '../../common/LoadButton';
import { PARTNER_ADD_EXPERT } from '../../../constants/routes.constants';
import { ErrorMessage } from '@hookform/error-message';
import ChallengeModal from '../../common/ChallengeModal';
import PartnerHeader from '../school/PartnerHeader';
import { addExpertErrors } from '../../../constants/error.constants';
import customizeBannerUpload from '../../../assets/images/upload-ic.svg';

const EditExpert = () => {
  const _NOT_SELECTED = '';
  const history = useHistory();
  const pageRedirect = () => {
    history.goBack();
  }
  const [isLoading, setIsLoading] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [imageName, setImageName] = useState("");
  const profileImage = useRef();
  const { register, watch, handleSubmit, setError, errors, getValues } = useForm({
    mode: 'onBlur',
  });


  const expertOptions = [
    { value: _NOT_SELECTED, label: 'Select...' }
  ];

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 48,
      color: '#321b6d',
      fontWeight: '400',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#321b6d',
    }),
    menu: (provided) => ({
      ...provided,
    }),
  };

  const getExperts = () => {

  }

  const getExpertDetails = () => {

  }

  useEffect(() => {
    getExperts();
  }, [])

  const onSubmit = handleSubmit((formData) => {
    setIsLoading(true);
    const params = getValues()
  })

  const handleDelete = () => {

  }

  const handleCloseDeleteConfirm = () => setShowDeleteConfirm(false);

  return (
    <div className='partner-wrapper-main'>
      <PartnerHeader />
      <ChallengeModal
        handleClose={handleCloseDeleteConfirm}
        handleAction={handleDelete}
        show={showDeleteConfirm}
        type="confirm"
        level="warning"
        button1Label="Delete"
        button2Label="Cancel"
      >
        <div>
          <span>Are you sure you want to delete this camp?</span>
        </div>
      </ChallengeModal>
      <div className='add-more-branches partner_add_challenges'>
        <span className="back-btn" onClick={pageRedirect}><HiOutlineChevronLeft /></span>
        <Container>
          <div>
            <div className='right-btn text-right' onClick={() => history.push(PARTNER_ADD_EXPERT)}>
              <button className='common-round-btn edit-button button btn btn-primary gred-btn'>Add an Expert</button>
            </div>
            <div className="d-flex justify-content-center">
              <div className='a-challenge-partner'>
                <h2 className='mb-60'>Edit an Expert</h2>
                <Form>
                  <Form.Group className="mb-3" controlId="">
                    <FormLabel>Select Expert</FormLabel>
                    <Select
                      options={expertOptions}
                      styles={customStyles}
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: '6px',
                        colors: {
                          ...theme.colors,
                          primary: '#80e4e1',
                        },
                      })}
                    // onChange={(e) => (setSelectedTreehouse(e.value))}
                    />
                  </Form.Group>
                </Form>

                <Form className='mt-50 mb-40' onSubmit={onSubmit}>
                  <Form.Group controlId="formFile" className="mb-3 upload-image">
                    <div className='customize-user-img'>
                      <Image src={imageName} alt="" />
                      <span className='customize-banner-upload' onClick={() => profileImage.current.click()}><Image src={customizeBannerUpload} alt="" /></span>
                      <input
                        className="d-none"
                        accept="image/png, image/jpeg, image/jpg, .heic, .HEIC"
                        id='profile_picture'
                        name='profile_picture'
                        type="file"
                        ref={profileImage}
                      // onChange={(e) => handleProfileImageSelection(e)}
                      />
                    </div>
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="">
                    <FormLabel>First Name</FormLabel>
                    <FormInput
                      name="firstName"
                      className="form-input"
                      data-testid="firstName"
                      ref={register({
                        required:
                          addExpertErrors.firstName.required,
                      })}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="name"
                      className="small text-danger"
                      as="label"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="">
                    <FormLabel>Last Name</FormLabel>
                    <FormInput
                      name="lastName"
                      className="form-input"
                      data-testid="lastName"
                      ref={register({
                        required:
                          addExpertErrors.lastName.required,
                      })}
                    />
                    <ErrorMessage
                      errors={errors}
                      name="name"
                      className="small text-danger"
                      as="label"
                    />
                  </Form.Group>

                  <Form.Group className="container-fluid flex-btn">
                    <LoadButton
                      className="common-round-btn submit-btn mt-5 w-100 gred-btn"
                      text="Save Changes"
                      isLoading={isLoading}
                      testid="submit"
                    />
                  </Form.Group>
                </Form>

              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  )
}
export default EditExpert;